export default class ValidationError extends Error {
    constructor(path, message) {
        super(path ? `[${path}] ${message}` : message);
        this.name = "ValidationError";
    }
}